module.exports = __webpack_public_path__ + "static/c2-c4d88217ab655f51ca5cf8bfd61b1ef7.png";